export const channelConstant = {
    // whatsapp: '605a319f9051d0d0bb128235',
    // callOtp: '605a31106c6ea54f88a2d10a',
    // email: '605cc7d104e6bdf477694cb3',
    // chatAja: '605cc7f904e6bdf477694cb5',
    // sms: '605cc81104e6bdf477694cb7',
    // call: '605cc83504e6bdf477694cb9',
    // smsOtp: '605cc84904e6bdf477694cba'
    whatsapp: '605a319f9051d0d0bb128235',
    voiceOtp: '605a31106c6ea54f88a2d10a',
    email: '605cc7d104e6bdf477694cb3',
    sms: '605cc81104e6bdf477694cb7',
    call: '605cc83504e6bdf477694cb9',
    smsOtp: '605cc84904e6bdf477694cba'
}

export default { channelConstant };